import { render, staticRenderFns } from "./filteredSmsForm.vue?vue&type=template&id=3ab2fa74&scoped=true&"
import script from "./filteredSmsForm.vue?vue&type=script&lang=js&"
export * from "./filteredSmsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab2fa74",
  null
  
)

export default component.exports